module.exports = __webpack_public_path__ + "img/sessions.4370f547.svg";